import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Caisse from "../pages/Caisse/Caisse";
import Settings from "../pages/Caisse/Settings";
import ListDesCommandes from "../pages/Caisse/ListDesCommandes";

import Vendeur from "../pages/Caisse/Vendeur";
import UserProfile from "../pages/Authentication/user-profile";
import { Navigate } from "react-router-dom";
import DevAccess from "../pages/Caisse/DevAccess";
import Maintenance from "../pages/Caisse/Maintenance";
import Reparation from "../pages/Caisse/Reparation";
import Stock from "../pages/Caisse/Stock";
import MonStock from "../pages/Caisse/MonStock";
import Mouvements from "../pages/Caisse/Mouvements";
import DashboardEcommerce from "../pages/Caisse/DashboardEcommerce/index";
import ListDesDevis from "../pages/Caisse/ListDesDevis";
import WaitingOrders from "../pages/Caisse/WaitingOrders";
import OrdersToDispatch from "../pages/Caisse/OrdersToDispatch";
import ListDesPickups  from "../pages/Caisse/ListDesPickups";
import ListDesExpeditions from "../pages/Caisse/ListDesExpeditions";
import ListDesFactures from "../pages/Caisse/ListDesFactures";
import OrdersToStock from "../pages/Caisse/OrdersToStock";
import path from "path/win32";


const authProtectedRoutes = [
    { path: "/profile", component: <UserProfile /> },
    { path: "/index", component: <DashboardEcommerce /> },

    { path: "/caisse", component: <Caisse />, requiredInterface: "caisse" },
    { path: "/vendeur", component: <Vendeur />, requiredInterface: "vendeur" },
    { path: "/commandes", component: <ListDesCommandes />, requiredInterface: "commandes" },
    { path: "/stock", component: <Stock />, requiredInterface: "stock" },
    { path: "/monstock", component: <MonStock />, requiredInterface: "stock" },
    { path: "/mouvements", component: <Mouvements />, requiredInterface: "stock" },
    { path: "/devis", component: <ListDesDevis />, requiredInterface: "commandes" },
    { path: "/preparation", component: <Reparation />, requiredInterface: "stock" },
    { path: "/CommandesEnAttentes", component: <WaitingOrders />, requiredInterface: "stock" },
    { path: "/piecesenattentes", component: <OrdersToDispatch />, },
    {path: "/CommandesStock", component: <OrdersToStock />,  },   
    { path: "/pickups", component: <ListDesPickups />},
    { path: "/expeditions", component:<ListDesExpeditions />, requiredInterface: "stock"},
    { path: "/factures",component:<ListDesFactures />, requiredInterface: "commandes"},
    { path: "/introuvable", component: <Maintenance /> },
    { path: "/logout", component: <Logout /> },
    { path: "/", exact: true, component: <Navigate to="/" /> },
]

const publicRoutes: any = [
    {
        path: "/",
        exact: true,
        component: <Navigate to="/login" />,
    },
    { path: "*", component: <Navigate to="/login" /> },
    { path: "/login", component: <Login /> },
    { path: "/dev-access", component: <DevAccess /> },


];

export { authProtectedRoutes, publicRoutes };